module.exports = __webpack_public_path__ + "media/img/pages/companies/comet_new-63e2ebe1d9ed6d697f677a5f0723d4fa.png";